/** Активный демо-период: полный функционал тарифа «Бизнес». */
export function hasActiveDemoAccess(tenant, billing) {
  if (!tenant) return false;
  if (billing) {
    return Boolean(billing.is_trial && billing.is_paid && !billing.is_demo_expired);
  }
  return tenant.status === "trial";
}

export function hasFullPlanAccess(club, tenant, billing) {
  if (hasActiveDemoAccess(tenant, billing)) return true;
  return tenant?.plan_tier === "club" || club?.plan_tier === "club";
}
